import Img from './Img.styled'

export default Img
